import {
  createHttpTenantRepository,
  type TenantRepository,
} from "@nasam/core";
import { authHttpClient } from "./auth";

export const tenantRepository: TenantRepository =
  createHttpTenantRepository(authHttpClient);
